/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseFromJSONTyped,
    MediaListApiResponseToJSON,
} from './MediaListApiResponse';
import {
    PrtimesMediaListsJoinResponseAllOf,
    PrtimesMediaListsJoinResponseAllOfFromJSON,
    PrtimesMediaListsJoinResponseAllOfFromJSONTyped,
    PrtimesMediaListsJoinResponseAllOfToJSON,
} from './PrtimesMediaListsJoinResponseAllOf';

/**
 * response of POST /prtimes_media_lists/join
 * @export
 * @interface PrtimesMediaListsJoinResponse
 */
export interface PrtimesMediaListsJoinResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof PrtimesMediaListsJoinResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof PrtimesMediaListsJoinResponse
     */
    message: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PrtimesMediaListsJoinResponse
     */
    mediaOutletIds: Array<number>;
}

export function PrtimesMediaListsJoinResponseFromJSON(json: any): PrtimesMediaListsJoinResponse {
    return PrtimesMediaListsJoinResponseFromJSONTyped(json, false);
}

export function PrtimesMediaListsJoinResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListsJoinResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'mediaOutletIds': json['media_outlet_ids'],
    };
}

export function PrtimesMediaListsJoinResponseToJSON(value?: PrtimesMediaListsJoinResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'media_outlet_ids': value.mediaOutletIds,
    };
}

